import {Component, Input} from '@angular/core';
import {TableModel} from './table-model';

/**
 * Reusable simple generic vertical column table. Which expected to used within Migration UI only.
 */
@Component({
	selector: 'app-table',
	templateUrl: './table.component.html',
	styleUrls: ['./table.component.scss']
})
export class TableComponent {

	/**
	 * CSS class to apply to every th tag in column header row.
	 */
	@Input() columnClassName = '';

	/**
	 * See TableModel doc.
	 */
	@Input() tableModel: TableModel<any>;

}
